import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { AuthService } from '../../../_services/auth.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
// import { Cloudinary } from '@cloudinary/angular-5.x';
import { CourseService } from '../../../_services/course.service';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../_services/global.service';
import { DomSanitizer } from '@angular/platform-browser';
import { IDeactivateComponent } from '../../../_models/i-deactivate';

@Component({
  selector: 'iq-central-front-end-edit-pdf',
  templateUrl: './edit-pdf.component.html',
  styleUrls: ['./edit-pdf.component.scss'],
})
export class EditPdfComponent
  implements OnInit, OnDestroy, IDeactivateComponent {
  delete_token: any;
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.contentForm.dirty && !this.isSubmited) {
      $event.returnValue = true;
    }
  }
  sub: Subscription = new Subscription();
  cloudName = 'cctlf-org';
  unsignedUploadPreset = 'n3zbglni';
  cloudinaryUrl = `https://api.cloudinary.com/v1_1/${this.cloudName}/upload`;
  uploadProgress = 0;
  file: any;
  contentForm: UntypedFormGroup;
  isSubmited = false;
  filePath: any;
  url: any;
  lessonId: any;
  courseCode: any;
  go: boolean;
  duration: any;
  name: any;
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [['bold']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };
  contentType: any;
  hasBaseDropZoneOver: boolean;
  uploader: FileUploader;
  title: string;
  response: any;
  fileName: any;
  content: any;
  fileUrl: any;
  type: any;
  contentId: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private _toastr: ToastrService,
    // private cloudinary: Cloudinary,
    private _course: CourseService,
    private _global: GlobalService,
    private sanitizer: DomSanitizer
  ) {
    this.title = '';
  }

  ngOnInit(): void {
    this.route.data.subscribe((res) => {
      this.content = res['resolvedData'].responseResult;
      this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.content.filePath
      );
      this.type = this.content.lessonContent.contentType;
    });

    this.initContentForm();
    this.lessonId = this.route.snapshot.paramMap.get('id');
    this.courseCode = this.route.snapshot.paramMap.get('code');
    this.contentId = this.route.snapshot.paramMap.get('contentId');

    // this.uploadToCloudinary();
  }
  initContentForm() {
    this.contentForm = this.fb.group({
      name: [this.content.lessonContent.name, Validators.required],
      description: [
        this.content.lessonContent.description,
        Validators.required,
      ],
    });
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  finish() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This content will be saved and you will be taken to your courses',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Save',
    }).then((result) => {
      if (result.value) {
        this.isSubmited = true;
        this.updateContent();
      }
    });
  }

  addMoreContent(path) {
    this.isSubmited = true;
    this._global.showSpinner();
    this.updateContent(path);
  }

  updateContent(path?) {
    this.isSubmited = true;

    let contentType = (this.contentType =
      typeof this.contentType === 'undefined' ? this.type : this.contentType);
    if (contentType === 'pdf') {
      const payload = this.contentForm.value;
      payload.contentType = 'pdf';
      payload.duration = this.duration;
      payload.fileName = this.fileName;
      payload.filePath = this.filePath;
      payload.lessonId = this.lessonId;

      this.sub.add(
        this._course.updateContentPdf(this.contentId, payload).subscribe({
          next: (res) => {
            this._global.hideSpinner();
            this._toastr.info('Content updated successfully ');
            if (path) {
              this.router.navigate(['courses/add-lesson', this.courseCode]);
            } else {
              this.router.navigate(['courses/course-details', this.courseCode]);
            }
          },
        })
      );
    } else {
      this._toastr.warning(
        'Unsupported format please make sure you are uploading a file with the supported format'
      );
    }
  }

  convertPagesToReadTimeInMinutes(noOfPages) {
    const oneWordInPages = 0.0036;
    //convert pages to words
    var noOfWords = noOfPages / oneWordInPages;
    //convert noOfWords to readTime
    //On an average, 130 words are read per minute so,
    var readTimeInMinutes = Math.round(noOfWords / 130);
    return readTimeInMinutes;
  }

  // uploadToCloudinary() {
  //   const uploaderOptions: FileUploaderOptions = {
  //     url: this.cloudinaryUrl,
  //     autoUpload: true,
  //     // Use xhrTransport in favor of iframeTransport
  //     isHTML5: true,
  //     // Calculate progress independently for each uploaded file
  //     removeAfterUpload: true,
  //     // XHR request headers
  //     headers: [
  //       {
  //         name: 'X-Requested-With',
  //         value: 'XMLHttpRequest',
  //       },
  //     ],
  //   };
  //   this.uploader = new FileUploader(uploaderOptions);
  //   this.uploader.onBuildItemForm = (fileItem: any, form: FormData): any => {
  //     form.append('upload_preset', this.cloudinary.config().upload_preset);
  //     let tags = 'content';
  //     if (this.title) {
  //       form.append('context', `photo=${this.title}`);
  //       tags = `content,${this.title}`;
  //     }
  //     form.append('folder', 'pdf Contents For IQCentral');
  //     form.append('tags', tags);
  //     form.append('file', fileItem);
  //     fileItem.withCredentials = false;

  //     return { fileItem, form };
  //   };
  //   this.uploader.onSuccessItem = (item, response, status, Headers) => {
  //     if (response) {
  //       const res = JSON.parse(response);
  //       this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
  //         res.secure_url
  //       );
  //       this.filePath = res.secure_url;
  //       this.duration = this.convertPagesToReadTimeInMinutes(res.pages);
  //       this.fileName = res.original_filename;
  //       this.contentType = res.format;
  //       this.delete_token = res.delete_token;
  //       console.log(res, this.contentType);
  //     }
  //   };
  //   this.uploader.onProgressItem = (fileItem: any, progress: any) => {
  //     this.go = true;
  //     this.fileName = fileItem;
  //     this.uploadProgress = progress;
  //   };

  //   this.uploader.onErrorItem = (status) => {
  //     this._global.handleNetworkError();
  //   };
  // }
  deleteFileFromCloudiary() {
    this.sub.add(
      this._course.deleteFileFromCloudinary(this.delete_token).subscribe({
        next: (res) => { },
      })
    );
  }
  canExit(): boolean | Promise<boolean> {
    if (
      confirm(
        'Are you sure you want to leave this page? Any unsaved changes will be lost'
      )
    ) {
      // this.deleteFileFromCloudiary();
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
